import { createStyles } from '@mantine/styles';


export default createStyles((
    theme: {
        colors: { [x: string]: any[] };
        other: any;
        spacing: any;
        colorScheme: any;
        shadows: any;
        radius: any;
        fn: any;
    }) => ({

    videoPlayer: {
        borderRadius: theme.radius.xs,
        overflow: 'hidden',
    },

}));
